
//MIDI utility functions

//May be useful: https://github.com/dingram/jsmidgen

var exports = module.exports;

var midiNoteMap = {
	'C': 0,
	'C♯': 1,
	'D♭': 1,
	'D': 2,
	'D♯': 3,
	'E♭': 3,
	'E': 4,
	'F': 5,
	'F♯': 6,
	'G♭': 6,
	'G': 7,
	'G♯': 8,
	'A♭': 8,
	'A': 9,
	'B♭': 10,
	'A♯': 10,
	'B': 11
};

exports.getMidiNoteNum = function getMidiNoteNum(noteName, octaveNum) {
	//Middle C = C4 in this system
	//Middle C = MIDI note 60
	var relativeNoteVal = midiNoteMap[noteName];
	if (relativeNoteVal == undefined) {
		throw new Error("Unrecognized note: '"+noteName+"'");
	}
	return 12 * (octaveNum + 1) + relativeNoteVal;
}

//exports.getNoteNameAndOctave(19)

exports.getNoteNameAndOctave = function getNoteNameAndOctave(midiNoteNum) {
	if (midiNoteNum == undefined) {
		throw new Error('midiNoteNum is required');
	}

	var octaveNum = Math.floor(midiNoteNum / 12);
	var relativeNoteVal = midiNoteNum - octaveNum * 12;
	octaveNum--;

	for (var noteName in midiNoteMap) {
		if (midiNoteMap[noteName] == relativeNoteVal) {
			break;
		}
	}

	return {note: noteName, octave: octaveNum};
}